import {MainDiamondCard} from "./MainDiamondCard";
import type {Card} from "../model/types";
import {useMainDiamondsCarousel} from "../model/hooks/useMainDiamondsCarousel";
import styles from "./MainDiamonds.module.scss";

type Props = {
    cards: Card[];
}

export const MainDiamondsMobile = ({cards}: Props) => {
    const {carouselRef} = useMainDiamondsCarousel(cards.length);
    return (
        <div className={styles.carousel}>
            <div className={`globalContainer`}>
                <div ref={carouselRef} className={styles.carouselViewport}>
                    <div className={styles.carouselContainer}>
                        {cards.map((card) => {
                            return (
                                <MainDiamondCard key={card.link} card={card} className={styles.carouselSlide} />
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
